import { api } from './api';
import { Church, ChurchDiscountPlatformMappings, ChurchDiscountSettings, ChurchQuery } from '../types';

const API = Object.freeze({
  church: '/church',
  churchById: '/church/{id}',
  churchIsActive: '/church/{id}/isActive',
  churchPublic: '/public/church',
  settings: {
    churchDiscount: '/settings/discounts/church',
    churchDiscountPlatforms: '/settings/discounts/church/platforms',
  },
  infoMessage: '/info-message',
  infoMessageById: '/info-message/{id}',
  infoMessageIsActive: '/info-message/{id}/isActive',
  infoMessagePublic: '/public/info-message',
});

export const getChurches = async (query: ChurchQuery) => {
  const params = new URLSearchParams();
  if (query.search) params.set('search', query.search);
  if (typeof query.isActive === 'boolean') params.set('isActive', String(query.isActive));
  const res = await api.get<Church[]>(API.church, { params });
  return res.data;
};

export const getChurchById = async (id: string) => {
  const res = await api.get<Church>(API.churchById.replace('{id}', id));
  return res.data;
};

export const createChurch = async (payload: Church) => {
  const res = await api.post<Church>(API.church, payload);
  return res.data;
};

export const updateChurch = async (id: string, payload: Church) => {
  const res = await api.put<Church>(API.churchById.replace('{id}', id), payload);
  return res.data;
};

export const toggleChurchActive = async (id: string, isActive: boolean) => {
  const res = await api.patch<Church>(API.churchIsActive.replace('{id}', id), { isActive });
  return res.data;
};

export const deleteChurch = async (id: string) => {
  const res = await api.delete<{ success: boolean; detachedMembers: number }>(API.churchById.replace('{id}', id));
  return res.data;
};

export const getPublicChurches = async (search?: string) => {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  const res = await api.get<Church[]>(API.churchPublic, { params });
  return res.data;
};

export const getChurchDiscountSettings = async () => {
  const res = await api.get<ChurchDiscountSettings>(API.settings.churchDiscount);
  return res.data;
};

export const updateChurchDiscountSettings = async (payload: ChurchDiscountSettings) => {
  const res = await api.put(API.settings.churchDiscount, payload);
  return res.data;
};

export const getChurchDiscountPlatformMappings = async () => {
  const res = await api.get<ChurchDiscountPlatformMappings>(API.settings.churchDiscountPlatforms);
  return res.data;
};

export const updateChurchDiscountPlatformMappings = async (payload: ChurchDiscountPlatformMappings) => {
  const res = await api.put(API.settings.churchDiscountPlatforms, payload);
  return res.data;
};
